import { Group, ThemeIcon, Text } from "@mantine/core";
import { IconCoin } from "@tabler/icons-react";
import useCatchFirestoreError from "@/hooks/useCatchFirestoreError";
import useGetTotalMoedasTodosRegulamentos from "@/modules/desafios-activities-per-colaborador/components/desafio-patrocinio-form/useGetTotalMoedasTodosRegulamentos";
import useGetRegulamentosDesafios from "@/src/modules/regulamento-desafios/hooks/useGetRegulamentos";

const TotalCoinsColaboradorDesafios = () => {
  const { data: regulamentos, error: regulamentoError } = useGetRegulamentosDesafios();
  useCatchFirestoreError(regulamentoError);
  const regulamentosAtivos = regulamentos?.filter(
    (regulamento) =>
      (!regulamento.dataFinal || new Date() <= new Date(regulamento.dataFinal)) &&
      (!regulamento.dataInicial || new Date() >= new Date(regulamento.dataInicial))
  );

  const totalMoedas =
    regulamentosAtivos?.reduce(
      (total: number, regulamento) => total + (regulamento.quantidadeMoedasPorColaborador || 0),
      0
    ) || 0;
  const { data: totalMoedasTodosRegulamentos } = useGetTotalMoedasTodosRegulamentos(regulamentosAtivos);
  const totalMoedasGastas: number =
    Array.isArray(totalMoedasTodosRegulamentos) && totalMoedasTodosRegulamentos.length > 0
      ? totalMoedasTodosRegulamentos.reduce((total: number, moedas: number) => total + moedas, 0) || 0
      : 0;
  return (
    <Group>
      <ThemeIcon variant="light" color="yellow" bg="transparent" size="xs">
        <IconCoin />
      </ThemeIcon>
      <Text c="#000" size="xs" tt="lowercase">
        {`${totalMoedas - totalMoedasGastas} moedas disponíveis para patrocinar desafios.`}
      </Text>
    </Group>
  );
};

export default TotalCoinsColaboradorDesafios;
